import { render, staticRenderFns } from "./UnapprovedMessage.vue?vue&type=template&id=7de0e2fe"
import script from "./UnapprovedMessage.vue?vue&type=script&lang=js"
export * from "./UnapprovedMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports